import React from "react";
import HeroSection from "./HeroSection";
import Cards from "./Cards";
import KeyFocus from "./KeyFocus";

const Research = () => {
  return (
    <div>
      <HeroSection />
      <Cards />
      <KeyFocus />
    </div>
  );
};

export default Research;
